export default __webpack_public_path__ + "static/media/PPI-walkway-010.3040a3cb.jpg";